// extracted by mini-css-extract-plugin
export var active = "Indicator-module--active--9a0c9";
export var flurp = "Indicator-module--flurp--ca4d1";
export var indicator = "Indicator-module--indicator--ebe60";